import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { merge, isEmpty } from 'lodash';

import moment from 'moment';
import { formatDateTime } from '@utils/datetime';

import { selectCurrentUser, selectIsHospital } from '@components/Auth';
import { PaymentMethods } from '@models/PaymentInfo';
import { selectCorporateHealthPolicyClaim } from './selector';
import { FormValues, formValuesSchema } from '../HealthPolicyClaim/schema';

export const useInitialValues = () => {
  const currentUser = useSelector(selectCurrentUser)
  const isHospital = useSelector(selectIsHospital);
  const { policy, user } = useSelector(selectCorporateHealthPolicyClaim);
  const initialValues: FormValues = formValuesSchema.getDefault() as unknown as FormValues;

  return useMemo(() => {
    if (!policy || !user) return;

    const isUserMainInsuredPerson = user.relationshipType === 'self';
    let useMainContact = !isUserMainInsuredPerson && isEmpty(user.mobileNumber);
    let mobileNumber = useMainContact ? (user.selfUser?.mobileNumber ?? '') : (user.mobileNumber ?? '');
    let email = useMainContact ? (user.selfUser?.email ?? '') : (user.email ?? '');

    if (isHospital) {
      useMainContact = false;
      mobileNumber = currentUser?.mobileNumber ?? '';
      email = currentUser?.email ?? '';
    }

    merge(initialValues, {
      policyHolder: user.name,
      policyNumber: policy.policyNumber ?? '',
      policyOrderNumber: policy.orderNumber,
      policyExpiryDate: moment(new Date(formatDateTime(policy.endedAt))).format('YYYY-MM-DDTHH:mm'),
      useMainContact: useMainContact,
      mobileNumber: mobileNumber,
      email: email,
      paymentInfo: {
        paymentMethod: isHospital ? PaymentMethods.BankTransfer : '',
        beneficiaryName: isHospital ? currentUser?.businessPartner.beneficiaryName : user.name,
        bankName: isHospital ? currentUser?.businessPartner.bankName : '',
        bankAccount: isHospital ? currentUser?.businessPartner.bankAccountNumber : '',
      }
    });

    return initialValues;
  }, [user, policy, isHospital, currentUser]);
};
